/* ⚠ Button's sets with no "use client": a Server Component importing a value
   from ./button gets an opaque client reference, not the object. The union
   stays in ./button (sibling specs read it there) and is imported type-only. */

import type { ButtonSize, ButtonVariant } from "./button";

export type { ButtonSize, ButtonVariant };

/** The variants Figma publishes for both surfaces, so the only ones `tone` is offered on. */
export type ButtonTonedVariant = Extract<ButtonVariant, "tertiary" | "ai" | "tonal">;

/**
 * The closed set, asserted at runtime because the type never sees CMS data.
 * `styles[variant]` indexes the whole CSS-module export map, so an off-contract
 * string does not degrade, it COLLIDES. hasOwnProperty rather than `in`, which
 * walks the prototype and would wave "constructor" through.
 */
export const BUTTON_VARIANTS: Record<ButtonVariant, true> = {
  ai: true,
  glass: true,
  primary: true,
  secondary: true,
  specialty: true,
  specialtyPurple: true,
  tertiary: true,
  tonal: true
};

export const TONED_VARIANTS: Record<ButtonTonedVariant, true> = {
  ai: true,
  tertiary: true,
  tonal: true
};

/** Whether `tone` means anything on this variant. */
export function isToned(variant: string): variant is ButtonTonedVariant {
  return Object.prototype.hasOwnProperty.call(TONED_VARIANTS, variant);
}

/**
 * The size set, asserted at runtime like BUTTON_VARIANTS (button.shared.ts):
 * an off-contract string COLLIDES rather than degrades — `size: "iconOnly"`
 * renders a labelled button as a 56px square.
 */
export const BUTTON_SIZES: Record<ButtonSize, true> = {
  large: true,
  medium: true,
  small: true,
  xSmall: true
};
